import { render, staticRenderFns } from "./HeatedDiscussion2.vue?vue&type=template&id=14b044b8&scoped=true&lang=html"
import script from "./HeatedDiscussion2.vue?vue&type=script&lang=js"
export * from "./HeatedDiscussion2.vue?vue&type=script&lang=js"
import style0 from "./HeatedDiscussion2.vue?vue&type=style&index=0&id=14b044b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b044b8",
  null
  
)

export default component.exports